import { render } from "./SignMandateModal.vue?vue&type=template&id=2d53e172"
import script from "./SignMandateModal.vue?vue&type=script&lang=js"
export * from "./SignMandateModal.vue?vue&type=script&lang=js"
script.render = render

export default script